var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReGenerate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C8.61667 21 6.50833 20.25 4.675 18.75C2.84167 17.25 1.68333 15.3333 1.2 13H3.25C3.71667 14.7667 4.66667 16.2083 6.1 17.325C7.53333 18.4417 9.16667 19 11 19C12.4333 19 13.7667 18.6458 15 17.9375C16.2333 17.2292 17.2 16.25 17.9 15H15V13H21V19H19V17C18.05 18.2667 16.875 19.25 15.475 19.95C14.075 20.65 12.5833 21 11 21ZM1 9V3H3V5C3.95 3.73333 5.125 2.75 6.525 2.05C7.925 1.35 9.41667 1 11 1C13.3833 1 15.4917 1.75 17.325 3.25C19.1583 4.75 20.3167 6.66667 20.8 9H18.75C18.2833 7.23333 17.3333 5.79167 15.9 4.675C14.4667 3.55833 12.8333 3 11 3C9.56667 3 8.23333 3.35417 7 4.0625C5.76667 4.77083 4.8 5.75 4.1 7H7V9H1Z",
    fill: "url(#paint0_linear_1061_2988)",
    stroke: "url(#paint1_linear_1061_2988)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1061_2988",
    x1: 1,
    y1: 11,
    x2: 21,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1061_2988",
    x1: 1,
    y1: 11,
    x2: 21,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReGenerate);
export default __webpack_public_path__ + "static/media/re-generate.d95762d33d5a5fdf2870a62183bc3eb7.svg";
export { ForwardRef as ReactComponent };